import { useParams } from 'react-router-dom';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import ModalDialog, {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { generateApiPath } from 'src/utils';
import { useStoreUnitActions } from 'src/redux/helpers';
import solutionsStore from '../../redux';
import { API_DELETE_ASSET_MODEL } from '../../constants';
import { SolutionAssetConfigListItem } from '../../types';

type Props = {
  item: SolutionAssetConfigListItem;
  open: boolean;
  onClose: ModalCloseHandler;
  twinId?: string;
};

function SolutionAssetModelDeleteModal({ item, open, onClose, twinId }: Props) {
  const { solutionId } = useParams();
  const { showAlert } = useAlert();
  const actions = useStoreUnitActions(solutionsStore);

  const [handleDelete, loading] = useStatefulApi(
    () =>
      pepApiRequest({
        method: RequestMethod.Delete,
        url: generateApiPath(API_DELETE_ASSET_MODEL, {
          solutionId,
          twinId,
          assetId: item?.id,
          fileId: item?.fileId,
        }),
        useProxy: true,
      }),
    () => {
      showAlert({
        type: AlertType.Success,
        title: 'Asset model file deleted',
        text: `Asset model file ${item?.fileName} has been deleted successfully.`,
      });
      onClose(null, ModalCloseReason.completeAction);
      actions.assetModelData({ solutionId, twinId });
    },
    (err) => {
      showAlert({
        type: AlertType.Error,
        title: 'Failed to delete asset model file',
        text: 'Error while deleting the file.',
      });
    }
  );

  return (
    <ModalDialog
      open={open}
      title="Delete Asset Model File"
      loading={loading}
      onClose={onClose}
      onConfirm={handleDelete}
      cancelBtnText="No"
      confirmBtnText="Yes"
      maxWidth="sm"
      fullWidth
    >
      Are you sure you want to delete the asset model file?<br></br>
      <b>{item?.fileName || ''}</b>
    </ModalDialog>
  );
}

export default SolutionAssetModelDeleteModal;
